function fallback () {
	this.$router.go(-1)
}


function computedCost (price, number) {
	if(price !== '' && number !== '') {
		if((price == 0)) {
			return 0
		}
		if(number == 0) {
			return price * 10000
		}
		let computedPrice = (price * 10000) / number
		return Math.round(computedPrice)
	}else {
		return ''
	}
}
function computedTotal (jj, yh, mh, xmt,zyhz,wgj, qt) {
	if(jj !== '' && yh !== '' && mh !== '' && qt !== ''&& xmt !== '' && zyhz !== '' && wgj !== '') {
		let total = Number(jj) + Number(yh) + Number(mh) + Number(qt) + Number(xmt) + Number(zyhz) + Number(wgj)
		return total.toFixed(2)
	} else {
		return ''
	}
}

function detailComputed (number, date) {
    let y = new Date().getFullYear()
    let m = new Date().getMonth() + 1
    let d = new Date().getDate()

    if(d != 1) {
        d -= 1
    }

    if (number !== '') {
        if (date[0] == y && date[1] == m) {
            return Math.round((number / getDates(date[1], date[0])) * d)
        } else {
            return Math.round(number)
        }
    }
}

function validate (val, require) {
	if(require === 'require') {
		if(val !== ''){
			return true
		}else{
			return false
		}
	}
}

function urlParse () {
	let url = window.location.search
	let obj = {}
    let reg = /[?&][^?&]+=[^?&]+/g
    let arr = url.match(reg)
    if(arr) {
      arr.forEach((item) => {
        let tempArr = item.substring(1).split('=')
        let key = decodeURIComponent(tempArr[0])
        let val = decodeURIComponent(tempArr[1])
        if(key === 'hosid') {
        	val = val.split(',')
        }
        obj[key] = val
      })
    }
    return obj
}

function saveToLocal (key, val) {
	let userInfo = window.localStorage.userInfo
	if (!userInfo) {
		userInfo = {}
	} else {
		userInfo = JSON.parse(userInfo)
	}
	userInfo[key] = val
	window.localStorage.userInfo = JSON.stringify(userInfo)
}

function loadFromLocal (key, def) {
	let userInfo = window.localStorage.userInfo
	if (!userInfo) {
		return def
	}
	let ret = JSON.parse(userInfo)[key]
	return ret || def
}

function getCurrentTime () {
	let keep = ''
	let date = new Date()
	let y = date.getFullYear()
	let m = date.getMonth() + 1
	let d = date.getDate()
	keep = y + '-' + m + '-' + d
	return keep
}


function getDay(num, str) {
    var today = new Date()
    var nowTime = today.getTime()
    var ms = 24 * 3600 * 1000 * num
    today.setTime(parseInt(nowTime + ms))
    var oYear = today.getFullYear()
    var oMoth = (today.getMonth() + 1).toString()
    if (oMoth.length <= 1) oMoth = '0' + oMoth
    var oDay = today.getDate().toString()
    if (oDay.length <= 1) oDay = '0' + oDay
    return oYear + str + oMoth + str + oDay
}


function getDates(month,year){
    var curDate = new Date()
    if(year) {
    	curDate = new Date(year)
    }
    /*  生成实际的月份: 由于curMonth会比实际月份小1, 故需加1 */
    curDate.setMonth(month);
    /* 将日期设置为0, 这里为什么要这样设置, 我不知道原因, 这是从网上学来的 */
    curDate.setDate(0)
    /* 返回当月的天数 */
    return curDate.getDate()
}

function defPickerDate () {
	let newArrar = []
	let y = new Date().getFullYear()
	for(let i = 1900;i <= y + 100;i++) {
		newArrar.push({
			value: i + '年',
			children: [{
					value: '1月'
				},{
					value: '2月'
				},{
					value: '3月'
				},{
					value: '4月'
				},{
					value: '5月'
				},{
					value: '6月'
				},{
					value: '7月'
				},{
					value: '8月'
				},{
					value: '9月'
				},{
					value: '10月'
				},{
					value: '11月'
				},{
					value: '12月'
				}
			]
		})
	}
	return newArrar
}
function defPickerAnchor () {
	let y = new Date().getFullYear() + '年'
	let m = (new Date().getMonth() + 1) + '月'
	return [{
		value: y

	},{
		value: m
	}]
}
export {
	fallback,
	computedCost,
	computedTotal,
	validate,
	urlParse,
	saveToLocal,
	loadFromLocal,
	getCurrentTime,
	getDay,
	getDates,
	defPickerDate,
    defPickerAnchor,
    detailComputed
}



// WEBPACK FOOTER //
// ./src/assets/js/_mm.js